import { GetStateFunction, DispatchFunction } from "../reducers";
import { processProgram as processProgramAPI } from "../api/workouts";
import { addError, addSuccess } from "./notifications";
import { PROCESSING_PROGRAM } from "./types";

export interface ProcessProgramResult {
    message?: string;
    success: boolean;
}

export const processProgram = (programKey: string)  => async (dispatch: DispatchFunction, getState: GetStateFunction): Promise<ProcessProgramResult> => {
    try {
        dispatch({ type: PROCESSING_PROGRAM, payload: true });
        await processProgramAPI(programKey);
        dispatch(addSuccess('Program processed successfully.'));

        return { success: true };
    } catch (e: any) {
        if (e.userFriendly) {
            dispatch(addError(e.message));

            return {
                message: e.message,
                success: false,
            };
        } else {
            dispatch(addError('An error occurred while processing the selected program.'));

            return {
                message: e.response?.data?.message || e.message,
                success: false,
            };
        }

    } finally {
        dispatch({ type: PROCESSING_PROGRAM, payload: false });
    }
}
